import React from 'react';
import { showNotification, WishlistCheckboxButton } from '@navi-toolbox/ui-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'typesafe-actions';
import { detectDeviceFromUserAgent } from 'features/products/components/products-carousel/utils';
import { NotificationTemplates } from 'types/notification';

export type Props = {
  productId: string;
  inShoppingList: boolean;
  hasText?: boolean;
  size: 's' | 'm' | 'l';
  onShoppingListToggle: (nextInShoppingList: boolean) => void;
};

export const WishlistButton: React.FC<Props> = ({
  productId,
  hasText = false,
  size,
  inShoppingList,
  onShoppingListToggle,
}) => {
  const { t } = useTranslation();

  const userAgentFromState = useSelector(({ userAgent }: RootState) => userAgent);
  const { isDesktop } = detectDeviceFromUserAgent(userAgentFromState);

  const text =
    (hasText &&
      (inShoppingList
        ? t('ui.product-card.shopping-list-checkbox-label-checked')
        : t('ui.product-card.shopping-list-checkbox-label'))) ||
    '';

  const tooltipText = inShoppingList
    ? t('ui.product-card.shopping-list-tooltip-remove')
    : t('ui.product-card.shopping-list-tooltip-add');

  const showAddNotification = () => {
    showNotification({
      templateId: NotificationTemplates.Wishlist,
      data: {
        text: t('ui.product-card.shopping-list-snack-add'),
        buttonText: t('ui.product-card.shopping-list-button-go-to'),
        buttonHref: '/shopping-list/',
        inWishList: true,
      },
    });
  };

  const showRemoveNotification = () => {
    showNotification({
      templateId: NotificationTemplates.Wishlist,
      data: {
        text: t('ui.product-card.shopping-list-snack-remove'),
        buttonText: t('ui.product-card.shopping-list-button-revert'),
        inWishList: false,
        onClick: () => {
          onShoppingListToggle(true);
          showAddNotification();
        },
      },
    });
  };

  const handleAddClick = () => {
    onShoppingListToggle(true);
    showAddNotification();
  };

  const handleRemoveClick = () => {
    onShoppingListToggle(false);
    showRemoveNotification();
  };

  const handleClick = inShoppingList ? handleRemoveClick : handleAddClick;

  return (
    <WishlistCheckboxButton
      isInteractive={!!productId}
      text={text}
      tooltipText={tooltipText}
      isDesktop={isDesktop}
      size={size}
      isChecked={inShoppingList}
      onClick={handleClick}
    />
  );
};
